export default {
  usedTEF: false,
};
